import { Vue, Component } from 'vue-property-decorator';
import { ContradictoryCheckListItemDTO } from '@/../client-generator/generated-clients/quality';
import qualityClient from '@/core/api/quality-service';
import { LOADING_CONTENT } from '@/core/store/types/action-types';

@Component
export default class ContradictoryCheckListComponent extends Vue {
  contradictoryChecks: ContradictoryCheckListItemDTO[] = [];

  async fetchQualityControls() {
    this.$store.dispatch(LOADING_CONTENT, true);
    try {
      const response = await qualityClient.myContradictoryList();

      this.contradictoryChecks = response as ContradictoryCheckListItemDTO[];
    } catch (error) {
      let messageError = 'error';

      switch (error.status) {
        case 401:
          messageError = this.$t('apiErrors.unauthorized').toString();
          break;
        case 403:
          messageError = this.$t('apiErrors.forbidden').toString();
          break;
        default:
          messageError = this.$t('apiErrors.serverError').toString();
      }

      this.$message.error(messageError);
    } finally {
      this.$store.dispatch(LOADING_CONTENT, false);
    }
  }
}
